import { select, call } from 'redux-saga/effects';
import {
  AMSRefreshHoursSelector,
  isAMSEnabledSelector,
} from '../../reducers/app/configuration';
import {
  AMSSegmentsSelector,
  userNumberSelector,
} from '../../reducers/app/params';
import {
  getSegmentsDataKey,
  getUserSegmentsData,
} from '../../../utils/segments';
import FEATURES from '../../../constants/featureToggling';
import { getGrowthBook } from '../../../services/growthbook';
import { localStorageAccessor } from '../../../utils/localStorage';

export function* setAmsOrderingToLocalStorage() {
  const isAmsEnabled: ReturnType<typeof isAMSEnabledSelector> = yield select(
    isAMSEnabledSelector
  );
  const segments: ReturnType<typeof AMSSegmentsSelector> = yield select(
    AMSSegmentsSelector
  );

  const isOrderingEnabled =
    getGrowthBook().isOn(FEATURES.AMS_ORDERING) && isAmsEnabled;

  const userNumber = yield select(userNumberSelector);

  const lcKey = getSegmentsDataKey(userNumber);
  const segmentsData = getUserSegmentsData(lcKey);

  localStorageAccessor(lcKey, { ...segmentsData, isOrderingEnabled, segments });
}

export function* orderingWatcher() {
  yield call(setAmsOrderingToLocalStorage);

  const userNumber: ReturnType<typeof userNumberSelector> = yield select(
    userNumberSelector
  );

  const lcKey = getSegmentsDataKey(userNumber);
  const segmentsData = getUserSegmentsData(lcKey);

  if (!segmentsData.isOrderingEnabled) {
    return;
  }

  // if in use - check time, if no - just write it
  const refreshTimeInterval: ReturnType<typeof AMSRefreshHoursSelector> =
    yield select(AMSRefreshHoursSelector);
  // we have refreshTime in hours, so we have to match format
  const refreshTime = refreshTimeInterval * 3600000;

  const timeDifference = Date.now() - segmentsData?.timestamp;

  if (timeDifference > refreshTime) {
    const segments: ReturnType<typeof AMSSegmentsSelector> = yield select(
      AMSSegmentsSelector
    );
    segmentsData.segments = segments;
    segmentsData.timestamp = Date.now();
    localStorage.setItem(lcKey, JSON.stringify(segmentsData));
  }
}
